
/* eslint-disable no-undef */
export const SocialNetworks = {
  props: ['useAdobe', 'dealerCode','manufacturer', 'pageName', 'channel', 'hier', 'pageNoName', 'lang'],
  data(){
    return {
      useFordAdobe: (this.useAdobe ? this.useAdobe : false),
      fordDealerCode: (this.dealerCode ? this.dealerCode : ''),
      adobePageName: (this.pageName ? this.pageName : ''),
      adobeChannel: (this.channel ? this.channel : ''),
      adobeHier: (this.hier ? this.hier : ''),
      adobePageNoName: (this.pageNoName ? this.pageNoName : ''),
      adobeLanguage: (this.lang ? this.lang : ''),
      dealerManufacturer: (this.manufacturer ? this.manufacturer : ''),
    }
  },
  methods: {
    socialNetworkClick(social) {
      var payload = {'event_category': 'LBX-SocialNetwork', 'event_label': 'LBX-Header-Sales'};
      window.sendGAEvent('LBX-' + social + '-Click', payload);
      console.log("GTAG SENT " +  'LBX-' + social + '-Click'); 
    
      //console.log(this.fordDealerCode); 

      if(this.useFordAdobe && this.fordDealerCode){
        digitaldata.onclick = digitaldata.onclick || {};
        digitaldata.page = digitaldata.page || {};
        digitaldata.vehicle = digitaldata.vehicle || {};
        digitaldata.user = digitaldata.user || {};
        digitaldata.event = digitaldata.event || {};
        digitaldata.page.pageName = this.adobePageName;
        digitaldata.page.siteSection = this.adobeChannel;
        digitaldata.page.hierarchy = this.adobeHier;
        digitaldata.page.userLanguage = this.adobeLanguage;
        digitaldata.page.pageNameNoVehicle = this.adobePageNoName;
        digitaldata.page.client =  this.dealerManufacturer;
        digitaldata.page.site = "dc:leadbox:ca";
        digitaldata.page.tool = "event:click to call";
        digitaldata.page.toolDescriptor = "click to call:{global | vehicle details}";
        digitaldata.page.radUIVersion =  window.innerWidth < 768 ? 'ui:rad:mobile' : window.innerWidth < 992 ? 'ui:rad:tablet' : 'ui:rad:pc';
        digitaldata.onclick.onclick = "social:"+social.toLowerCase();
        digitaldata.onclick.onclickLinkName = "dc:social:"+social.toLowerCase();
        digitaldata.event.action = social.toLowerCase() +"|tool";
        digitaldata.user.paCode = this.fordDealerCode;
        typeof(_satellite) !== "undefined" ? _satellite.track("global-onclick") : (function(){console.warn("'_satellite' is not defined"); return null; })();
        console.log("DIGITAL DATA " + "social:"+social.toLowerCase()); 
        //console.log(digitaldata);
      }
    },
  },
}